import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

export default StyleSheet.create({
  //Headlines
  HeadlineBold: {
    fontFamily: FONTS.boldFont,
    fontSize: 40,
  },
  Headline2Bold: {
    fontFamily: FONTS.boldFont,
    fontSize: 32,
  },
  HeadlineBold28: {
    fontFamily: FONTS.boldFont,
    fontSize: 28,
  },
  Headline4Bold: {
    fontFamily: FONTS.boldFont,
    fontSize: 24,
  },
  Headline4Regular: {
    fontFamily: FONTS.regularFont,
    fontSize: 24,
  },
  //Here 22 after the style name signifies a custom font size, this is being done because
  //the design system fails to mention a name for this exact style
  Headline4SemiBold22: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 22,
  },
  Headline4SemiBold: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 24,
  },
  Headline5SemiBold: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 20,
  },
  //Body
  Body1Regular: {
    fontFamily: FONTS.regularFont,
    fontSize: 16,
  },
  Body1SemiBold: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 16,
  },
  Body1Bold18: {
    fontFamily: FONTS.boldFont,
    fontSize: 18,
  },
  Body1Bold: {
    fontFamily: FONTS.boldFont,
    fontSize: 16,
  },
  Body1Italic: {
    fontFamily: FONTS.regularItalic,
    fontSize: 16,
  },
  Body2: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 14,
    textDecorationLine: 'underline',
    lineHeight: 20,
  },

  //Text
  Text1Regular: {
    fontFamily: FONTS.regularFont,
    fontSize: 14,
  },
  Text1Bold: {
    fontFamily: FONTS.boldFont,
    fontSize: 14,
  },
  Text1RegularItalic: {
    fontFamily: FONTS.regularItalic,
    fontSize: 14,
  },
  Text1SemiBold: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 14,
  },
  Text2SemiBold: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 12,
  },
  Text2Medium: {
    fontFamily: FONTS.mediumFont,
    fontSize: 12,
  },
  Text2Regular: {
    fontFamily: FONTS.regularFont,
    fontSize: 12,
  },
  Text3Regular: {
    fontFamily: FONTS.regularFont,
    fontSize: 10,
  },

  //Subtitle
  Subtitle1SemiBold: {
    fontFamily: FONTS.semiboldFont,
    fontSize: 18,
  },
  Subtitle1Bold: {
    fontFamily: FONTS.boldFont,
    fontSize: 18,
  },
  Subtitle2Bold: {
    fontFamily: FONTS.boldFont,
    fontSize: 20,
  },
  Subtitle1Regular: {
    fontFamily: FONTS.regularFont,
    fontSize: 18,
  },
  Subtitle2Regular: {
    fontFamily: FONTS.regularFont,
    fontSize: 14,
  },
});
